import React from 'react';
import GameBoard from '../components/GameBoard.js';
import level2Data from '../data/level2Data.js';

const Level2 = () => {
  return (
    <GameBoard
      catPosition={level2Data.catPosition}
      catImage={level2Data.catImage}
      backgroundImage={level2Data.backgroundImage}
      nextLevel={level2Data.nextLevel}
    />
  );
};

export default Level2;
